'use client';

import React from 'react';
import Link from 'next/link';
import styles from './LogoutButton.module.scss';
import Cookies from 'js-cookie';
import { Button } from '@mantine/core';
import { useDictionary } from '@/src/dictionaries/dictionary-provider';

const LogoutButton =
  () => {
    const token = Cookies.get('authToken');
    const dictionary = useDictionary();

    const handleLogout = () => {
      Cookies.remove('authToken');
      window.location.reload();
    };

    console.log(token)
    if (!token) {
      return (
        <Button className={styles.login} component={Link} href="/login">
          {dictionary.header.login}
        </Button>
      );
    }

    return (
      <Button className={styles.logout} component={Link} href="/admin">
        {dictionary.header.dashboard}
      </Button>
    );
  };

export default LogoutButton;
